/**
 * useFilterOptions Hook
 * 
 * Custom hook for fetching filter options (job levels and users)
 */

import { useQuery } from '@tanstack/react-query';
import { FeedApiService } from '../feedApiService';
import { FilterOptions } from '../types';

export const useFilterOptions = () => {
    return useQuery<FilterOptions, Error>({
        queryKey: ['filterOptions'],
        queryFn: () => FeedApiService.fetchFilterOptions(),
        staleTime: 5 * 60 * 1000, // 5 minutes - options don't change frequently
        gcTime: 10 * 60 * 1000, // 10 minutes cache time
    });
};
